import { Link } from "react-router-dom";
import { useSite } from "@/lib/site";
import { fileUrl } from "@/lib/api";

export const Logo = ({ className = "h-11 md:h-12", testId = "site-logo", dark = false }) => {
  const { settings } = useSite();
  return (
    <Link to="/" data-testid={testId} className="inline-flex items-center gap-3 shrink-0">
      <img src={fileUrl(settings?.logo_url || "/logo-transparent.png")} alt="شعار هِمّة تم" className={`${className} w-auto object-contain`} />
      <span className="hidden sm:flex flex-col leading-tight">
        <span className={`font-display font-extrabold text-base ${dark ? "text-white" : "text-[var(--ink)]"}`}>{settings?.site_name || "أكاديمية هِمّة تم"}</span>
        <span className={`text-[11px] ${dark ? "text-white/60" : "text-[var(--muted-ink)]"}`}>مهارات المستقبل</span>
      </span>
    </Link>
  );
};
